import React from "react";

import { css } from "@emotion/css";

import { useStyles } from "@/hooks/useStyles.ts";
import { PatientMedicalFile } from "@/pages/patient-medical-file/PatientMedicalFile.tsx";
import { PageContent } from "@/uiKit/atoms/page/PageContent.tsx";

export const PatientMedicalFilePage: React.FC = () => {
  const styles = useStyles(makeStyles);

  return (
    <PageContent id="patient-medical-file-page" className={styles.content}>
      <PatientMedicalFile />
    </PageContent>
  );
};

const makeStyles = () => ({
  container: css({}),
  content: css({
    paddingTop: "2vh",
  }),
});
